import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface CategoryCardProps {
  emoji: string;
  title: string;
  subtitle: string;
  isBonus?: boolean;
  index: number;
}
function CategoryCard({
  emoji,
  title,
  subtitle,
  isBonus = false,
  index
}: CategoryCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} className={`relative p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 ${isBonus ? 'border-2 border-amber-300' : 'border border-rose-100'}`} initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} whileHover={{
    y: -5
  }} data-id="element-134">
      {isBonus && <div className="absolute -top-3 right-4 px-3 py-1 bg-gradient-to-r from-amber-400 to-amber-500 text-white text-xs font-bold rounded-full shadow-md" data-id="element-135">
          BONO ⭐
        </div>}
      <div className="text-4xl mb-3" data-id="element-136">{emoji}</div>
      <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-137">{title}</h3>
      <p className={`text-sm ${isBonus ? 'text-amber-600 font-medium' : 'text-slate-500'}`} data-id="element-138">
        {subtitle}
      </p>
    </motion.div>;
}
export function IncludedSection() {
  const categories = [{
    emoji: '🎂',
    title: 'Tarjetas de Cumpleaños',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '🎁',
    title: 'Packaging & Etiquetas',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '💌',
    title: 'Invitaciones Editables',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '🎈',
    title: 'Decoración con Globos',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '🏳️',
    title: 'Banderines',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '🔢',
    title: 'Números 3D',
    subtitle: '+1.000 diseños'
  }, {
    emoji: '🌸',
    title: 'Flores de Papel',
    subtitle: 'Bono especial ⭐',
    isBonus: true
  }, {
    emoji: '🎨',
    title: 'Libritos para Pintar',
    subtitle: 'Bono especial ⭐',
    isBonus: true
  }, {
    emoji: '💐',
    title: 'Día de la Madre',
    subtitle: 'Bono especial ⭐',
    isBonus: true
  }, {
    emoji: '🏫',
    title: 'Etiquetas de Colegio',
    subtitle: 'Bono especial ⭐',
    isBonus: true
  }, {
    emoji: '🔤',
    title: 'Letras 3D',
    subtitle: 'Bono especial ⭐',
    isBonus: true
  }, {
    emoji: '🎪',
    title: '+15 Carpetas más',
    subtitle: 'Miles de diseños'
  }];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-139">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        {/* Header */}
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-141">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-142">
            📂 ¿Qué incluye tu compra?
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500 mb-4" data-id="element-143">
            26 Carpetas Repletas de Magia para tus Fiestas 🎉
          </p>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-144">
            Más de 1.000 diseños por carpeta, organizados por categoría y listos
            para editar e imprimir desde el primer día.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-145">
          {categories.map((category, index) => <CategoryCard key={category.title} emoji={category.emoji} title={category.title} subtitle={category.subtitle} isBonus={category.isBonus} index={index} data-id="element-146" />)}
        </div>

        {/* Price reminder */}
        <motion.div className="mt-14 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-147">
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 px-8 py-5 bg-gradient-to-r from-pink-50 to-rose-50 border-2 border-rose-200 rounded-2xl" data-id="element-148">
            <span className="text-slate-700 font-semibold" data-id="element-149">
              Todo esto incluido por solo
            </span>
            <span className="text-3xl font-extrabold text-rose-600" data-id="element-150">
              $27.990 ARS
            </span>
            <a href="https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778" target="_blank" rel="noopener noreferrer" className="shimmer-btn px-6 py-2 bg-gradient-to-r from-rose-500 to-pink-500 text-white font-bold rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 text-sm" data-id="element-151">
              🛒 Comprar Ahora
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}